var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"ballon-container\">\n    <img src=\""
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"host") : depth0), depth0))
    + "/no_summary_flag.png\">\n    <span>"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Error.DataUnavailable",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":3,"column":10},"end":{"line":3,"column":42}}}))
    + "</span>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/summary-message.hbs
// module id = rAe7
// module chunks = 1